/// <amd-module name="Build/Flux/Store" />
import { IDisposable } from "Build/Flux/Common"

export type ListenerType = (eventName?: string) => void;

export class Store implements IDisposable {
    private _listeners: Array<ListenerType>;

    constructor() {
        this._listeners = [];
    }

    public addListener(listener: ListenerType) {
        this.addCustomListener(listener, this._listeners);
    }

    public removeListener(listener: ListenerType) {
        this.removeCustomListener(listener, this._listeners);
    }

    public dispose() {
        this._listeners = [];
    }

    protected addCustomListener(listener: ListenerType, listeners: Array<ListenerType>) {
        listeners = listeners || this._listeners || [];
        listeners.push(listener);
    }

    protected removeCustomListener(listener: ListenerType, listeners?: Array<ListenerType>) {
        listeners = listeners || this._listeners || [];
        const index = listeners.indexOf(listener);
        if (index > -1) {
            listeners.splice(index, 1);
        }
    }
    
    protected emitChanged(eventName?: string, listeners?: Array<ListenerType>) {
        listeners = listeners || this._listeners || [];
        listeners.forEach(listener => listener(eventName));
    }
}
